import React from 'react';
import './index.scss';
import splashLogo from '../../assets/logo/splash.png';

function SplashScreen() {
  return (
    <div className="splash-screen">
      <img src={splashLogo} alt="Logo" />
    </div>
  );
}

export default SplashScreen;
